import { CompanyLibraryState } from './reducers';
export const getCompanyLibrary = ({ pages: { companyLibrary } }) =>
  companyLibrary as CompanyLibraryState;
